<div
  id="user-{{ user.attributes.id }}"
  class="flex flex-row p-2 py-3 justify-between font-medium text-sm"
  (click)="selectedUser.emit(user)"
>
  <div class="flex items-center">
    <app-user-avatar
      class="ml-1 mr-2.5 shrink-0"
      [name]="user.attributes.full_name"
      [size]="40"
      [systemUser]="user.attributes.user_type === 'system'"
    ></app-user-avatar>
    <div class="flex flex-col justify-center">
      <div>
        {{ user.attributes.full_name }}
      </div>
      <span class="font-normal text-xs cursor-pointer">
        {{ user.attributes.email }}
      </span>
    </div>
  </div>
  <div class="flex flex-row items-center justify-end">
    <ion-icon name="chevron-forward" class="text-3xl text-grey-mid"></ion-icon>
  </div>
</div>
